// App Imports
import params from "../../../setup/config/params";
import index from "../index";

// Pages routes
const routes = {
  ratingFeedback: {
    path: (page = ':page') => `/ratingfeedbacks/${ page }`,
    activePath: '/ratingfeedback',
    component: index,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "feedback",
    action: "canView",
  },
};
/*export default {
  ratingFeedback: {
    path: '/ratingfeedback',
    component: index,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
  },
};*/

export default routes;